'use client';
import Link from 'next/link';
import Image from 'next/image';
import styles from './SimilarProducts.module.css';

export default function SimilarProducts({ currentProductId }) {
  const products = [
    {
      id: 'zinc',
      name: 'ZINC Premium',
      badge: 'Best Seller',
      specs: '60 Servings • 25mg • Capsules',
      price: '30.00DT',
      image: 'https://longevity20155.sirv.com/zinc/1.webp',
    },
    {
      id: 'minci',
      name: 'MINCI Advanced',
      badge: 'New',
      specs: '30 Servings • 500mg • Capsules',
      price: '35.00DT',
      image: 'https://longevity20155.sirv.com/minci/1.webp',
    },
    {
      id: 'testo',
      name: 'TESTO Boost',
      badge: 'Popular',
      specs: '45 Servings • 750mg • Capsules',
      price: '40.00DT',
      image: 'https://longevity20155.sirv.com/testo/1.webp',
    },
  ];

  // Filter out current product
  const similarProducts = products.filter(p => p.id !== currentProductId);

  return (
    <div className={styles.section}>
      <div className={styles.header}>
        <h2 className={styles.title}>Similar Products</h2>
        <Link href="/shop" className={styles.viewAll}>
          View All →
        </Link>
      </div>

      <div className={styles.grid}>
        {similarProducts.map((product) => (
          <Link 
            key={product.id} 
            href={`/product/${product.id}`}
            className={styles.card}
          >
            <div className={styles.badge}>{product.badge}</div>
            
            <div className={styles.imageContainer}>
              <Image 
                src={product.image} 
                alt={product.name}
                width={400}
                height={250}
                unoptimized
              />
            </div>

            <div className={styles.info}>
              <h3 className={styles.productName}>{product.name}</h3>
              <p className={styles.specs}>{product.specs}</p>
              <p className={styles.price}>{product.price}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
